/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Additional info for wizard pages [WizardPage only]
 * @export
 * @interface WizardPageInfo
 */
export interface WizardPageInfo {
    /**
     * 
     * @type {number}
     * @memberof WizardPageInfo
     */
    currentStepNumber: number;
    /**
     * 
     * @type {number}
     * @memberof WizardPageInfo
     */
    totalStepsNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WizardPageInfo
     */
    possiblyDirty: boolean;
}

/**
 * Check if a given object implements the WizardPageInfo interface.
 */
export function instanceOfWizardPageInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "currentStepNumber" in value;
    isInstance = isInstance && "possiblyDirty" in value;

    return isInstance;
}

export function WizardPageInfoFromJSON(json: any): WizardPageInfo {
    return WizardPageInfoFromJSONTyped(json, false);
}

export function WizardPageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardPageInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentStepNumber': json['currentStepNumber'],
        'totalStepsNumber': !exists(json, 'totalStepsNumber') ? undefined : json['totalStepsNumber'],
        'possiblyDirty': json['possiblyDirty'],
    };
}

export function WizardPageInfoToJSON(value?: WizardPageInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currentStepNumber': value.currentStepNumber,
        'totalStepsNumber': value.totalStepsNumber,
        'possiblyDirty': value.possiblyDirty,
    };
}

